import { PlaceholderType } from '@app/lib/inputs/RichEditor/types'

export const containsPlaceholders = (text): boolean | void => {
  return text.some((element) => {
    if ('type' in element) {
      if (element.type === PlaceholderType.Placeholder) {
        return true
      }
    }
    if ('children' in element) {
      return containsPlaceholders(element.children)
    }
  })
}
